export default __webpack_public_path__ + "static/timerbanner2-85040302386cea4e6a3be249ba9d1c24.png";